import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';
import actions from './actions';
import state from './state';
import getters from './getters';
import mutations from './mutations';

export const serviceComputed = {
	...mapGetters('fcFwdCkuStore', Object.keys(getters)),
	...mapState('fcFwdCkuStore', Object.keys(state))
};
export const serviceMethods = {
	...mapActions('fcFwdCkuStore', Object.keys(actions)),
	...mapMutations('fcFwdCkuStore', Object.keys(mutations))
};
